'use client';

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { CSSTransition } from 'react-transition-group';
const GlobalTransitions = createGlobalStyle`
  .nib-overlay-enter {
    opacity: 0.01;
  }

  .nib-overlay-enter-active {
    opacity: 1;
    transition: opacity .3s cubic-bezier(0.550, 0.085, 0.680, 0.530);
  }

  .nib-overlay-exit {
    opacity: 1;
  }

  .nib-overlay-exit-active {
    opacity: 0.01;
    transition: opacity .3s cubic-bezier(0.550, 0.085, 0.680, 0.530);
  }
`;
export const OverlayComponent = styled.div.attrs({
  'data-mesh-component': 'OVERLAY'
})`
  position: fixed;
  overflow: auto;
  z-index: 1;
  inset: 0;
  background-color: var(--overlayColorBg, rgb(67 67 67 / 90%));
`;
const Overlay = _ref => {
  let {
    visible = false,
    closeOnEsc = true,
    closeOnClick = true,
    onClose,
    children,
    ...otherProps
  } = _ref;
  const ref = useRef();
  function handleClick(event) {
    if (closeOnClick && event.target === ref.current) {
      onClose && onClose();
    }
  }
  useEffect(() => {
    function handleKeydown(event) {
      if (visible && closeOnEsc && event.key === 'Escape') {
        onClose && onClose();
      }
    }
    function enablePageScrolling() {
      document.body.style.overflow = '';
    }
    function disablePageScrolling() {
      document.body.style.overflow = 'hidden';
    }
    if (visible) {
      disablePageScrolling();
      document.addEventListener('keydown', handleKeydown);
    } else {
      enablePageScrolling();
      document.removeEventListener('keydown', handleKeydown);
    }
    return function cleanup() {
      enablePageScrolling();
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [visible, closeOnEsc, onClose]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(GlobalTransitions, {}), /*#__PURE__*/_jsx(CSSTransition, {
      timeout: 300,
      in: visible,
      classNames: "nib-overlay",
      mountOnEnter: true,
      unmountOnExit: true,
      nodeRef: ref,
      children: /*#__PURE__*/_jsx(OverlayComponent, {
        ...otherProps,
        ref: ref,
        onClick: handleClick,
        children: children
      })
    })]
  });
};
export default Overlay;